export function mobileFilterOpener() {
    const body = $("body");
    const catalogFilters = $(".catalog-holder .catalog-filters");
    body.on("click", ".open-filters", function () {
        body.addClass("mobile-filters-open");
        catalogFilters.addClass("show");
    });
    body.on("click", ".catalog-filters-mobile .close", function () {
        body.removeClass("mobile-filters-open");
        catalogFilters.removeClass("show");
    });
    $(".catalog-filters ul.woof_list_color li").on("click", function () {
        let title = $(this).find(".woof_color_title");
        if (title.hasClass("woof_checkbox_label_selected")) {
            title.removeClass("woof_checkbox_label_selected");
        } else {
            title.addClass("woof_checkbox_label_selected");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileFilterOpener.js